export default __webpack_public_path__ + "static/media/fourthh.f290d2c9.png";